export type IvrType = 'START' | 'ARS' | 'RINGING_GROUP' | 'DIRECT' | 'HANGUP' | 'PLAY' | 'CONDITION_DAY' | 'CONDITION_TIME' | 'CONDITION_DATE' | 'CONDITION_HOLIDAY' | 'REPEAT' | 'MENU_RETURN';

export const ttsModelLabels = {
  LOCAL: '로컬 모델 (SUPERTONIC)',
  'GEMINI2.5': 'Gemini 2.5 TTS',
  'GEMINI3.1': 'Gemini 3.1 TTS',
} as const;

export interface AudioFile {
  id: number;
  original_filename: string;
  filepath: string;
  size: number;
  created_at: string;
  created_by: number;
  group_id: number;
}

export interface IvrInfo {
  id: number;
  name: string;
  created_at: string;
  created_by: number;
  updated_at?: string;
  updated_by?: number;
  group_id: string;
}

export interface IvrContent {
  id: number;
  ivr_type: IvrType;
  ivr_info_id: number;
  audio_file_id?: number;
  is_enterance: 'Y' | 'N';
  ringing_group_id?: number;
  custom_title?: string;
  ps_endpoint_id?: string;
  name: string;
  group_id: string;
}

export interface IvrDtmf {
  id: number;
  ivr_contents_id: number;
  number: string;
  next_ivr_content_id: number;
  group_id: string;
}

export interface IvrRequest {
  name: string;
  graphVersion?: number;
  ivrGraphJson: any;
  ivrRuntimeJson: any;
}

export interface IvrResponse {
  id: number;
  name: string;
  graphVersion: number;
  ivrGraphJson: any;
  ivrRuntimeJson: any;
  createdAt?: string;
  updatedAt?: string;
}

export interface IvrListRequest {
  name?: string;
  page?: number;
  size?: number;
}

export interface PageIvrResponse {
  content: IvrResponse[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}
